<style scoped>
.svgContent {
  width: 100%;
  text-align: center
}
.icon-search {
  position: fixed;
  top: 120px;
  left: 2px;
  z-index: 999;
}
.searchBox {
  position: fixed;
  width: 200px;
  padding: 10px;
  background-color: #fff;
  height: auto;
  top: 100px;
  left: 0px;
  border: 1px solid #ccc;
  border-radius: 5px;
  z-index: 100;
}
.icon-close {
  position: absolute;
  top: 20px;
  left: 198px;
  cursor: pointer;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  background-color: #fff;
  border-radius: 0 5px 5px 0;
}
.lineRemark{
  position: fixed;
  right: 50px;
  top: 100px;
  width: 300px;
}
.lineOpen{
  margin: 0 auto;
  position: relative;
  outline: 0;
  width: 200px;
  top: 300px;
  background-color: rgba(0,0,0,.5);
  border: 0;
  border-radius: 6px;
  background-clip: padding-box;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  padding: 10px;
}
</style>

<template>
    <div>
        <div v-html="svgHtml" id="svgWorkPlatform" class="svgContent"></div>

        <Spin fix v-if="spinShow">
            <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
            <div>地图加载中...</div>
        </Spin>
    </div>
</template>

<script>
import { mapOperation } from '@/utils/mapOperation'

export default {
  mixins: [mapOperation], // 混入地图操作的方法
  data () {
    return ({
      pageType: 2,
      svgHtml: '',
      spinShow: false,
      chooseCity: '110100' // 默认选中城市
    })
  },
  mounted () {
    this.initMap()
    // 设置中间区域地图高度
    this.$nextTick(() => {
      document.getElementById('svgWorkPlatform').style.height = document.documentElement.clientHeight - 90 + 'px'
    })
  },
  methods: {
    initPageData () {
      let assetList = [7, 6]
      this.fillLineGray(assetList, [], 0)
    }
  },
  watch: {
    spinShow (val) {
      if (!val) {
        this.initPageData()
      }
    }
  }
}
</script>
